module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('relation-config', {
    attrs: {
      "cur-input": _vm.curInput,
      "input-list": _vm.inputList,
      "rules": _vm.rules,
      "field-name": 'multi_link'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75f8ac06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/multirelateConfig.vue
// module id = 1926
// module chunks = 2